import React from 'react';
import { Menu, X, Phone, Instagram, MapPin, Megaphone, UserCheck, Banknote, Gift, Clock, CreditCard, CheckCircle2, ArrowRight, Share } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./components/ui/accordion";

const AffiliatesPage = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleConsultation = () => {
    window.location.href = "https://booking.naver.com/booking/10/bizes/1337119/items/6484304";
  };

  const handleShare = async () => {
    const shareData = {
      title: 'ONTHEGROUND 주짓수',
      text: '대구 수성구 유일의 영어 몰입형 주짓수! 제 이름 말하고 등록하면 20만원 상당 혜택(도복+입관비 면제)을 받을 수 있어요.',
      url: 'https://onthegroundbjj.com',
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText('https://onthegroundbjj.com');
        alert('링크가 복사되었습니다! 친구에게 카톡으로 보내보세요.');
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden relative bg-white">
      
      {/* Sticky Call Button (Mobile Only) */}
      <div className="fixed bottom-4 right-4 left-4 z-50 md:hidden">
        <a href="tel:010-9879-0818" className="flex items-center justify-center gap-2 w-full bg-[#E63946] text-white font-bold py-4 rounded-full shadow-2xl hover:brightness-110 transition-all">
          <Phone className="w-5 h-5 fill-white" />
          전화로 상담하기
        </a>
      </div>

      {/* Navigation - Consistent with LandingPage */}
      <nav className="absolute w-full z-50 px-4 py-4">
        <div className="max-w-7xl mx-auto bg-white/90 backdrop-blur-md rounded-[25px] px-6 py-3 flex items-center shadow-md border border-blue-50 relative min-h-[64px]">
          {/* Centered Logo */}
          <a href="/" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-2 whitespace-nowrap">
             <span className="text-[#1A4392] font-['Poppins'] font-extrabold text-2xl tracking-tight">온더그라운드 주짓수</span>
          </a>
          
          {/* Desktop Menu - Right Aligned */}
          <div className="hidden md:flex items-center gap-8 ml-auto">
            <a href="/#features" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">특징</a>
            <a href="/#program" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">프로그램</a>
            <a href="/#reviews" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">후기</a>
            <button onClick={handleConsultation} className="btn-primary text-sm py-2 px-5 min-h-[40px]">
              상담 예약
            </button>
          </div>

          {/* Mobile Menu Toggle - Right Aligned */}
          <button className="md:hidden text-[#1A4392] ml-auto" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-20 left-4 right-4 bg-white/95 backdrop-blur-md rounded-2xl p-6 shadow-xl md:hidden flex flex-col gap-4 border border-blue-100 animate-in slide-in-from-top-2">
            <a href="/#features" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>특징</a>
            <a href="/#program" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>프로그램</a>
            <a href="/#reviews" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>후기</a>
            <button onClick={handleConsultation} className="btn-primary w-full">
              상담 예약하기
            </button>
          </div>
        )}
      </nav>

      {/* SECTION 1 — HERO */}
      <section className="pt-32 pb-4 px-4 bg-blue-50/50">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#1A4392] leading-tight font-['Poppins']">
            신규 회원을 소개하면<br />즉시 10만원을 드립니다.
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            회원님께는 <span className="font-bold text-[#E63946]">현금 10만원</span>을,<br className="md:hidden" />
            친구에게는 <span className="font-bold text-[#1A4392]">도복 + 입관비 면제</span> 혜택을 드립니다.<br />
            모두가 행복해지는 ONTHEGROUND 추천 혜택을 확인해보세요.
          </p>
        </div>
      </section>

      {/* NEW SECTION — BENEFITS BREAKDOWN (WIN-WIN) */}
      <section className="py-4 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Referrer Benefit */}
            <div className="bg-[#1A4392] text-white p-8 rounded-[32px] shadow-xl relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300">
               <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-bl-full -mr-8 -mt-8"></div>
               <div className="relative z-10">
                 <div className="flex items-center gap-3 mb-4">
                   <span className="bg-[#E63946] px-4 py-2 rounded-full text-base font-bold">추천인</span>
                   <h3 className="text-2xl font-bold text-white">소개해주신 회원님</h3>
                 </div>
                 <div className="space-y-2">
                   <p className="text-3xl md:text-4xl font-black text-[#D3FF62]">10만원 지급</p>
                   <p className="text-blue-100 text-lg">
                     ① 10만원 상품권<br/>
                     ② 또는 수강료 할인
                   </p>
                 </div>
               </div>
            </div>

            {/* Friend Benefit */}
            <div className="bg-white border-2 border-blue-100 p-8 rounded-[32px] shadow-xl relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300">
               <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-bl-full -mr-8 -mt-8"></div>
               <div className="relative z-10">
                 <div className="flex items-center gap-3 mb-4">
                   <span className="bg-[#1A4392] text-white px-4 py-2 rounded-full text-base font-bold">지인</span>
                   <h3 className="text-2xl font-bold text-[#1A4392]">소개받은 친구</h3>
                 </div>
                 <div className="space-y-2">
                   <p className="text-3xl md:text-4xl font-black text-[#E63946]">도복 무료</p>
                   <p className="text-gray-600 text-lg">
                     <span className="block font-medium mb-1 text-gray-800">10만원 상당 도복 제공</span>
                     상담 시 추천인 성함을 말씀해주시면<br/>
                     <span className="font-bold text-[#1A4392]">입관비 면제 혜택</span>과 함께 제공!
                   </p>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — HOW IT WORKS */}
      <section className="py-10 px-4 bg-blue-50/30">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-8 text-[#1A4392]">어떻게 진행되나요?</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Step 1 */}
            <div className="bg-white p-8 rounded-[32px] shadow-lg border border-blue-100 text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Megaphone className="w-8 h-8 text-[#1A4392]" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#1A4392]">1. 친구에게 혜택을 알려주세요</h3>
              <p className="text-gray-600 leading-relaxed">
                "내 이름을 말하고 등록하면<br/>
                <span className="font-bold text-[#E63946]">도복을 무료로 받을 수 있어!</span>"<br/>
                라고 혜택을 소개해주세요.
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-white p-8 rounded-[32px] shadow-lg border border-blue-100 text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <UserCheck className="w-8 h-8 text-[#1A4392]" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#1A4392]">2. 상담 시 '추천인' 언급 필수</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                친구가 상담할 때<br/>꼭 회원님의 성함을 말해야 합니다.
              </p>
              <div className="bg-blue-50 py-3 px-4 rounded-xl font-bold text-[#1A4392]">
                “○○○님이 추천해 주셨어요.”
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-white p-8 rounded-[32px] shadow-lg border border-blue-100 text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Banknote className="w-8 h-8 text-[#1A4392]" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#1A4392]">3. 등록 즉시 10만원 지급</h3>
              <p className="text-gray-600 leading-relaxed">
                친구가 등록을 완료하면,<br/>
                즉시 <span className="font-bold text-[#1A4392]">카카오페이 송금</span> 또는<br/>
                <span className="font-bold text-[#1A4392]">수강료 할인</span>을 해드립니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 — HOW TO REFER */}
      <section className="py-10 px-4 bg-blue-50/50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-8 text-[#1A4392]">어떻게 ‘추천’으로 인정되나요?</h2>
          
          <div className="bg-white p-8 md:p-12 rounded-[32px] shadow-md">
            <p className="text-lg text-gray-700 mb-8 text-center">
              방식은 매우 간단합니다.<br />
              아래 방법 중 편한 방법 한 가지만 하셔도 됩니다.
            </p>
            
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full shrink-0 mt-1">
                  <CheckCircle2 className="w-5 h-5 text-[#1A4392]" />
                </div>
                <div>
                  <p className="text-gray-700 text-lg">지인에게</p>
                  <p className="font-bold text-[#1A4392] text-lg">“등록할 때 제 이름을 추천인으로 말씀해 주세요.”</p>
                  <p className="text-gray-600">라고 미리 알려주기</p>
                </div>
              </li>
              
              <li className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full shrink-0 mt-1">
                  <CheckCircle2 className="w-5 h-5 text-[#1A4392]" />
                </div>
                <div>
                  <p className="text-gray-700 text-lg">지인이 도장에 오거나 연락할 때</p>
                  <p className="font-bold text-[#1A4392] text-lg">“○○○ 회원님께 추천받았습니다.”</p>
                  <p className="text-gray-600">라고 본인 성함을 말씀하도록 안내하기</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full shrink-0 mt-1">
                  <CheckCircle2 className="w-5 h-5 text-[#1A4392]" />
                </div>
                <div>
                  <p className="text-gray-700 text-lg mb-2">카카오톡으로 링크 보내기</p>
                  <button 
                    onClick={handleShare}
                    className="flex items-center gap-2 bg-[#FAE100] text-[#371D1E] px-4 py-2 rounded-lg font-bold text-lg shadow-sm hover:brightness-95 transition-all mb-2"
                  >
                    <Share className="w-5 h-5" />
                    링크 공유하기
                  </button>
                  <p className="text-gray-600">링크를 보내며 "등록할 때 내 이름 말하면 혜택 있어!"라고 알려주기</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full shrink-0 mt-1">
                  <CheckCircle2 className="w-5 h-5 text-[#1A4392]" />
                </div>
                <div>
                  <p className="text-gray-700 text-lg">또는 관장님 / 원장님께 직접</p>
                  <p className="font-bold text-[#1A4392] text-lg">“제가 ○○○님을 추천했습니다.”</p>
                  <p className="text-gray-600">라고 말씀해 주시기</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full shrink-0 mt-1">
                  <CheckCircle2 className="w-5 h-5 text-[#1A4392]" />
                </div>
                <div>
                  <p className="text-gray-700 text-lg">카카오톡으로</p>
                  <p className="font-bold text-[#1A4392] text-lg bg-gray-100 inline-block px-2 py-1 rounded mb-1 mt-1">추천: (본인 이름) → (지인 이름/연락처)</p>
                  <p className="text-gray-600">형식으로 메시지 보내기</p>
                </div>
              </li>
            </ul>

            <div className="mt-10 p-6 bg-blue-50 rounded-xl text-center border border-blue-100">
              <p className="text-[#1A4392] font-medium text-lg">
                위 방법 중 어떤 방식이든<br />
                <span className="font-bold">신규 회원 등록 시 ‘추천인 성함’만 확인되면</span><br />
                추천으로 인정됩니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — REWARDS DETAILS */}
      <section className="py-10 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-8 text-[#1A4392]">추천 보상 안내</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* 1. Amount */}
            <div className="bg-gray-50 p-8 rounded-[24px] border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <Gift className="w-6 h-6 text-[#E63946]" />
                <h3 className="text-xl font-bold text-gray-900">보상 금액</h3>
              </div>
              <p className="text-gray-700 text-lg">
                <span className="font-bold text-[#1A4392]">신규 회원 1명 소개 시마다 10만원</span>을 드립니다.
              </p>
            </div>

            {/* 2. Timing */}
            <div className="bg-gray-50 p-8 rounded-[24px] border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="w-6 h-6 text-[#E63946]" />
                <h3 className="text-xl font-bold text-gray-900">지급 시점</h3>
              </div>
              <p className="text-gray-700 text-lg">
                소개해 주신 분이 ONTHEGROUND 주짓수에 <span className="font-bold">신규 회원으로 등록</span>하고
                첫 4주 등록비를 결제한 <span className="font-bold text-[#1A4392]">당일 또는 익일에 지급</span>됩니다.
              </p>
            </div>

            {/* 3. Method */}
            <div className="bg-gray-50 p-8 rounded-[24px] border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <CreditCard className="w-6 h-6 text-[#E63946]" />
                <h3 className="text-xl font-bold text-gray-900">지급 방식</h3>
              </div>
              <ul className="text-gray-700 text-lg space-y-2 mb-4">
                <li>- <span className="font-bold">10만원 상품권</span></li>
                <li>- 또는 <span className="font-bold">회원님 수강료에서 10만원 할인</span></li>
              </ul>
              <p className="text-gray-600">두 가지 중에서 원하시는 방식으로 선택하실 수 있습니다.</p>
            </div>

            {/* 4. Conditions */}
            <div className="bg-gray-50 p-8 rounded-[24px] border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <CheckCircle2 className="w-6 h-6 text-[#E63946]" />
                <h3 className="text-xl font-bold text-gray-900">유효 조건</h3>
              </div>
              <ul className="text-gray-700 text-lg space-y-2">
                <li>- ONTHEGROUND 주짓수에 <span className="font-bold">처음 등록하는 ‘신규 회원’</span>만 해당됩니다.</li>
                <li className="text-base text-gray-600">- 예전에 다니다가 다시 등록하는 재등록 회원은 제외됩니다.</li>
                <li className="text-base text-gray-600">- 추천 횟수 제한은 없습니다.<br/>(신규 회원 1명당 10만원씩, 소개해 주시는 만큼 계속 지급됩니다.)</li>
                <li className="text-base font-bold text-[#1A4392] bg-blue-50 p-2 rounded-lg mt-2">- 모든 보상은 신규 회원이 주 2회 이상 등록 시 적용됩니다.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 — FAQ */}
      <section className="py-10 px-4 bg-blue-50/50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 text-[#1A4392]">자주 묻는 질문 (FAQ)</h2>
          </div>
          
          <Accordion type="single" collapsible className="w-full space-y-4">
            {[
              {
                q: "이런 혜택은 어떻게 가능한가요?",
                a: "총 혜택 금액(200,000원)은 약 한 달 수강료와 비슷합니다. 모든 학생이 한 달 이상 수련하기 때문에, 첫 달 수강료를 학생과 추천인에게 혜택으로 돌려드리고 저는 그 다음 달부터 수익을 얻는 구조입니다. 회원님은 보상을 받고, 친구는 할인을 받고, 도장은 성실한 학생을 얻는 모두가 좋은 시스템입니다."
              },
              {
                q: "체험만 하고 등록하지 않으면 어떻게 되나요?",
                a: "정식으로 신규 회원 등록 후 첫 결제(4주 등록비)가 이루어져야 추천 보상이 지급됩니다. 체험 수업만 듣고 등록하지 않는 경우에는 보상이 지급되지 않습니다."
              },
              {
                q: "성인 회원을 소개해도 보상이 되나요?",
                a: "네, 가능합니다. 키즈반, 청소년, 성인반 상관없이 ONTHEGROUND에 처음 등록하는 모든 신규 회원이 대상입니다."
              },
              {
                q: "추천 횟수 제한이 있나요?",
                a: "없습니다. 신규 회원 1명당 10만원씩, 소개해 주시는 만큼 계속 지급됩니다."
              },
              {
                q: "두 사람이 동시에 같은 사람을 추천했다고 하면 어떻게 되나요?",
                a: "추천 인정 기준은 신규 회원 본인이 처음으로 말씀해 주신 추천인 성함 기준입니다. 따라서 지인에게 미리 “등록할 때 제 이름을 추천인으로 말씀해 주세요.”라고 안내해 주시는 것을 권장드립니다."
              },
              {
                q: "수강료 할인 대신, 카카오페이만 받을 수도 있나요?",
                a: "네, 가능합니다. 보상을 받으실 때 ① 카카오페이 10만원 송금 / ② 수강료 10만원 할인 중 원하시는 방식을 선택해 주시면 됩니다."
              }
            ].map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border rounded-2xl px-4 bg-white shadow-sm">
                <AccordionTrigger className="text-left font-bold text-[#1A4392] text-base md:text-lg py-4 hover:no-underline">
                  Q. {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 text-base pb-4 leading-relaxed">
                  A. {item.a.split('**').map((part, index) => 
                    index % 2 === 1 ? <span key={index} className="font-bold text-gray-800">{part}</span> : part
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* SECTION 6 — COMMUNITY MESSAGE */}
      <section className="py-12 px-4 bg-white text-center">
        <div className="max-w-2xl mx-auto space-y-6">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium">
            ONTHEGROUND 주짓수는<br />
            회원님들의 따뜻한 소개와 신뢰로 성장하고 있습니다.
          </p>
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed">
            소중한 지인을 맡겨 주시는 만큼<br />
            더 안전하고, 더 재미있고, 더 성장할 수 있는 도장이 되겠습니다.
          </p>
          <p className="text-lg md:text-xl text-[#1A4392] font-bold pt-4">
            항상 응원해 주셔서 감사합니다.
          </p>
        </div>
      </section>

      {/* Footer - Consistent with LandingPage */}
      <footer className="bg-[#0F172A] text-white pt-12 pb-8 md:pt-20 md:pb-10 px-4">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-16">
          <div>
            <h3 className="text-2xl font-bold mb-6 font-['Poppins']">ONTHEGROUND</h3>
            <p className="opacity-70 mb-6 leading-relaxed">영어와 운동을 함께 배우는<br/>대구 유일의 프리미엄 키즈 주짓수</p>
            <div className="flex gap-4">
              <a href="https://instagram.com/onthegroundbjj" target="_blank" rel="noreferrer" className="bg-white/10 p-3 rounded-full hover:bg-[#E1306C] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-6 text-[#E63946] font-['Poppins']">Contact</h4>
            <ul className="space-y-4 opacity-80">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4" /> 010-9879-0818</li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4" /> @onthegroundbjj</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-[#E63946] font-['Poppins']">Location</h4>
            <p className="opacity-80 flex gap-2 leading-relaxed mb-4">
              <MapPin className="w-5 h-5 shrink-0" />
              대구 수성구 달구벌대로 2610 2층<br/>만촌역 3번 출구에서 232m
            </p>
            <a 
              href="https://map.naver.com/p/entry/place/1096514067" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-28 rounded-2xl overflow-hidden bg-white shadow-lg border border-white/20 hover:scale-[1.02] transition-transform duration-300 group relative"
            >
               <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors z-10 flex items-center justify-center">
                  <span className="bg-[#03C75A] text-white text-[10px] font-bold px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0 shadow-md whitespace-nowrap">
                    지도 보기
                  </span>
               </div>
               <img 
                 src="https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/na9l4hfc_image.png"
                 alt="Naver Map"
                 className="w-full h-auto object-cover"
               />
            </a>
          </div>

          <div>
             <button onClick={handleConsultation} className="w-full bg-white text-[#0F172A] py-4 rounded-xl font-bold hover:bg-blue-50 transition-colors shadow-lg">
               무료 상담 예약하기
             </button>
          </div>
        </div>
        
        <div className="max-w-7xl mx-auto border-t border-white/10 pt-8 text-center text-sm opacity-50 font-light">
          <p>&copy; 2025 ONTHEGROUND 주짓수. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default AffiliatesPage;
